import React from 'react'
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import HeaderContact from './HeaderContact';
import MainContact from './MainContact';

function Contact() {
  return (
    <div>
        <Navbar/>
        <HeaderContact/>
        <MainContact/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <Footer/>
    </div>
  )
}

export default Contact;